import(/* webpackMode: "eager" */ "/schnitt/components/site-header.tsx")